import type { ArticleContent, ContentBlock } from '@/lib/articleContent';

export function serializeArticleBody(body: ArticleContent): string {
  return JSON.stringify(body);
}

export function parseArticleBody(raw: string): ArticleContent {
  const trimmed = raw.trim();
  if (!trimmed) return { intro: '', blocks: [] };
  if (trimmed.startsWith('{')) {
    try {
      const p = JSON.parse(raw) as unknown;
      if (
        p &&
        typeof p === 'object' &&
        Array.isArray((p as ArticleContent).blocks)
      ) {
        return {
          intro:
            typeof (p as ArticleContent).intro === 'string'
              ? (p as ArticleContent).intro
              : '',
          blocks: (p as ArticleContent).blocks as ContentBlock[],
        };
      }
    } catch {
      /* fall through */
    }
  }
  return { intro: '', blocks: [{ type: 'paragraph', text: raw }] };
}
